import { createContext, useContext } from 'react';

import { getVariantStyles, isVibeFirstVariantActiveFromExperiments, StylesMap } from '@/utils/listingsVibeFirst';

export type ExperimentAssignment = {
  groupName: string;
  parameters: Record<string, unknown>;
};

export type ExperimentsData = Record<string, ExperimentAssignment>;

export const ExperimentsContext = createContext<ExperimentsData | undefined>(undefined);

export const ExperimentsProvider = ({
  children,
  experiments,
}: {
  children: React.ReactNode;
  experiments: ExperimentsData;
}) => {
  return <ExperimentsContext.Provider value={experiments}>{children}</ExperimentsContext.Provider>;
};

export const useExperiments = () => {
  const context = useContext(ExperimentsContext);
  if (context === undefined) {
    throw new Error('useExperiments must be used within an ExperimentsProvider');
  }
  return context;
};

export const useExperiment = (experimentName: string) => {
  const experiments = useExperiments();
  return experiments[experimentName];
};

export const useListingsVibeFirst = <T extends StylesMap>(
  defaultStyles: T,
  variantStyles?: T,
): { isVibeFirstVariantActive: boolean; styles: T } => {
  const experiments = useExperiments();
  const isVibeFirstVariantActive = isVibeFirstVariantActiveFromExperiments(experiments);
  const styles = getVariantStyles(isVibeFirstVariantActive, defaultStyles, variantStyles);
  return { isVibeFirstVariantActive, styles };
};
